<template>
    <v-card class="stat-card">
        <v-card-text>
            <div class="card-heading">
                <div class="card-title">Активных абонементов за</div>
                <v-select
                    v-model="period"
                    :items="periods"
                    return-object
                    item-text="name"
                    @change="onPeriodChange"
                    outlined
                    dense
                    hide-details
                />
                <div class="card-value">{{total}}</div>
            </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="mt-auto">
            <stat-active-cards-chart
                v-if="chartData"
                :chart-data="chartData"
                :height="158"
                class="card-chart"
            />
        </v-card-text>
    </v-card>
</template>

<script>
    import statisticApi from '../api/statistic.api';
    import StatActiveCardsChart from "./StatActiveCardsChart";

    export default {
        name      : "StatActiveCards",
        components: {StatActiveCardsChart},
        data() {
            return {
                chartData: null,
                total    : null,

                period : {
                    name : 'Последние 7 дней',
                    value: 'last_7_days'
                },
                periods: [
                    {
                        name : 'Все время',
                        value: 'all'
                    },
                    {
                        name : 'Последние 30 дней',
                        value: 'last_30_days'
                    },
                    {
                        name : 'Последние 7 дней',
                        value: 'last_7_days'
                    },
                ],
            }
        },
        created() {
            this.fetchStat();
        },
        methods   : {
            onPeriodChange() {
                this.chartData = null;
                this.fetchStat();
            },
            fetchStat() {
                this.$store.commit('setLoading', true);

                statisticApi.activeCards({period: this.period ? this.period.value : null}).then(({data}) => {
                    this.fillChartData(data.data);
                }).catch(() => {
                    this.$toast.error('Что-то пошло не так. Пожалуйста, повторите попытку позже');
                }).finally(() => {
                    this.$store.commit('setLoading', false);
                });
            },
            fillChartData(stats) {
                const data = [];

                stats.forEach((stat) => {
                    data.push({
                        x: stat.date,
                        y: stat.count,
                    });
                });

                this.chartData = {
                    datasets: [
                        {
                            label          : 'Активный абонементов ',
                            type           : 'bar',
                            data           : data,
                            fill           : false,
                            backgroundColor: '#19b7e8',
                            borderColor    : '#19b7e8',
                        }
                    ],
                };
            }
        }
    }
</script>

<style scoped>

</style>
